import { ProfileImage } from 'components/ProfileImage';
import { observer } from 'mobx-react-lite';
import React, { CSSProperties } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { PrimaryButton, SecondaryButton } from 'styleguide/Buttons';
import { colors } from 'styleguide/colors';
import { Modal } from 'styleguide/Modal';
import { H3, P2 } from 'styleguide/Texts';
import { themeState } from 'styleguide/theme';
import { t } from 'translations/t';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 544px;
  border-radius: 10px;
  @media (max-width: 1024px) {
    width: 300px;
  }
`;

const UpperContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px 16px 20px;
  margin: 0 -20px 16px -20px;
  border-bottom: 1px solid ${colors.greyLight};
`;

const MiddleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const LowerContainer = styled.div`
  display: flex;
  margin-top: 20px;
  justify-content: flex-end;
  padding: 16px 20px 0 20px;
  margin: 16px -20px 0 -20px;
  border-top: 1px solid ${colors.greyLight};
`;

export interface CoachInviteModalProps {
  coachName: string;
  coachProfilePic?: string;
  onAcceptInvite: () => void;
  onDeclineInvite: () => void;
  isOpen: boolean;
  onClose: () => void;
}

export const CoachInviteModal = observer(
  ({
    coachName,
    coachProfilePic,
    onAcceptInvite,
    onDeclineInvite,
    isOpen,
    onClose,
  }: CoachInviteModalProps) => {
    return (
      <ThemeProvider theme={themeState.current}>
        <Modal isOpen={isOpen} onClose={() => null}>
          <Container>
            <UpperContainer>
              <H3>{t('web.coachInviteModal.coachingInvite')}</H3>
            </UpperContainer>
            <MiddleContainer>
              <ProfileImage
                source={coachProfilePic}
                diameter={80}
                style={{ marginTop: 8, marginBottom: 24 }}
              />
              <P2>{t('web.coachInviteModal.coachingInvite.desc', { coachName })}</P2>
            </MiddleContainer>
            <LowerContainer>
              <SecondaryButton
                style={{ ...styles.button, marginInlineEnd: 16 }}
                title={t('web.coachInviteModal.decline')}
                onClick={() => {
                  onDeclineInvite();
                  onClose();
                }}
              />
              <PrimaryButton
                style={styles.button}
                title={t('web.coachInviteModal.accept')}
                onClick={() => {
                  onAcceptInvite();
                  onClose();
                }}
              />
            </LowerContainer>
          </Container>
        </Modal>
      </ThemeProvider>
    );
  },
);

const styles: { [key: string]: CSSProperties } = {
  button: {
    display: 'flex',
    width: 200,
  },
};
